import FocusTrap from 'focus-trap-react';
import React from 'react';
import { IconBack } from '../../../../Lib/Icons';
import { Button } from '../../../Core';
import './SlideOutMenu.scss';

interface ISlideOutMenuProps {
  closeMenu: () => void;
  visible: boolean;
}

const SlideOutMenu: React.FC<React.PropsWithChildren<ISlideOutMenuProps>> = ({ children, closeMenu, visible }) => {
  return (
    <>
      <FocusTrap
        active={visible}
        focusTrapOptions={{
          initialFocus: false,
          clickOutsideDeactivates: true,
        }}
      >
        <div className={'SlideOutMenu-Menu ' + (!!visible ? 'SlideOutMenu-show' : 'SlideOutMenu-hide')}>
          <div className="SlideOutMenu-Close">
            <Button
              subtle
              onClick={(e) => {
                closeMenu();
                e.stopPropagation();
              }}
            >
              <IconBack title="Close" size="34px" />
            </Button>
          </div>

          <div className="SlideOutMenu-Content">
            {/* Only render children when slide out menu is visible */}
            {!!visible && children}
          </div>
        </div>
      </FocusTrap>

      <div
        className={'SlideOutMenu-Shadow ' + (!!visible ? 'SlideOutMenu-show' : 'SlideOutMenu-hide')}
        onClick={(e) => {
          closeMenu();
          e.stopPropagation();
        }}
      />
    </>
  );
};

export default SlideOutMenu;
